<script lang="ts">
	import TemplateInputSettings from '../Components/TemplateInputSettings.svelte';
	import type { Device } from 'src/types/Device';

	export let device: Device;
</script>

<TemplateInputSettings
	{device}
	setting="humidity_offset"
	icon="far fa-droplet"
	min={-20}
	max={20}
	unit="%"
/>
